var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content.description)?_c('div',{staticClass:"guides__text container",domProps:{"innerHTML":_vm._s(_vm.content.description)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }